var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row service_builder_block" }, [
    _c("div", { staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12" }, [
      _c("div", { staticClass: "block-header" }, [
        _vm._v(" " + _vm._s(_vm.blocks.content.header) + " "),
      ]),
      _c("div", { staticClass: "block-data" }, [
        _vm._v(" " + _vm._s(_vm.blocks.content.description) + " "),
      ]),
    ]),
    _c("div", { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }, [
      _c("div", {
        staticClass: "link-data",
        domProps: { innerHTML: _vm._s(_vm.blocks.imagedata.text) },
      }),
      _c("div", { staticClass: "img-block" }, [
        _c("img", {
          staticClass: "img-width",
          attrs: {
            src: `${_vm.getImageUrl(_vm.blocks.imagedata.image)}`,
            alt: "img",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }